import React from 'react';
import { logoFullXml, logoMarkXml } from '../../assets/logoXml';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'full' | 'mark'; // full = logo + text, mark = just the tree icon
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 'md', variant = 'full' }) => {
  const sizeClasses = {
    sm: 'h-6 max-h-6 w-auto',
    md: 'h-8 max-h-8 w-auto',
    lg: 'h-10 max-h-10 w-auto'
  };

  const iconSizes = {
    sm: 'h-4 w-4 max-h-4 max-w-4',
    md: 'h-6 w-6 max-h-6 max-w-6',
    lg: 'h-8 w-8 max-h-8 max-w-8'
  };

  if (variant === 'mark') {
    return (
      <div className={`flex items-center justify-center ${iconSizes[size]} ${className}`}>
        <div dangerouslySetInnerHTML={{ __html: logoMarkXml }} />
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${sizeClasses[size]} ${className} overflow-hidden`}>
      <div className="w-full h-full" dangerouslySetInnerHTML={{ __html: logoFullXml }} />
    </div>
  );
};

export default Logo;
